<template>
  <div class="content">
    <div class="content-box">
      <div class="common left-content">
        <div class="content-title" v-for="(item, index) in titleList" :key="index" @mouseenter="changeTarget(item)"
          :style="target === item && 'border-bottom: 1px solid #CBB486;'" @click="getDetail(item)">
          <span :title="item.title">{{ item.title }}</span>
        </div>
        <!-- <div class="content-title" @mouseenter="focus = 2" :style="focus == 2 && 'border-bottom: 1px solid #CBB486;'">联系方式</div> -->
        <div class="content-desc" v-show="target.contentECount > 1 && target.moduleClass == 'announce'">
          <p v-for="item in list" :key="item.name" @click="goDetail(item)">
            <span>{{ item.contentTitle }}</span>
            <span v-if="String(item.createTime).length === 10">{{
              item.createTime
            }}</span>
            <span v-else>{{ String(item.createTime).split(" ")[0] }}</span>
          </p>
        </div>
        <div class="content-desc design-html" v-if="target.contentECount == 1 && target.moduleClass == 'announce'"
          v-html="data"></div>
        <div class="content-desc aaa" v-if="target.moduleClass == 'linkurl'">
          <!-- v-show="target === '便民检索'" -->

          <p v-for="itemSub in list" :key="itemSub.linkCode">
            <span style="font-size: 16px"><a class="cert-link" :href="itemSub.linkUrl" :title="'去往' + itemSub.linkUrl"
                target="_blank">{{ itemSub.linkTitle }}</a></span>
          </p>
        </div>
      </div>

      <div class="common right-content">
        <div class="right-box1">
          <p>我要查询查验</p>
          <div class="btn-wrap">
            <div @click="_getLink('RESBC899070F25B330')">外国附加证明书核查指南</div>
            <div @click="_getLink('RESC807153A8EA8E5F')">国内认证真伪查验</div>
          </div>
        </div>
        <div class="right-box2" @click="_getLink('RES427D66A88869383')">
          <p style="margin-top: 41px" @click="jumpNewUrl">
            <span style="display: block">福建省网上办事大厅</span>
            <span style="display: block">省外办分厅</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const list = [
  { name: "把服务做细----打造外事服务暖心工程", date: "2021-03-08" },
  { name: "中国公民寻求领事保护和服务指南", date: "2021-03-08" },
  { name: "各国驻华领馆领区认证管辖一览表", date: "2021-03-08" },
  { name: "用健全扎实的制度构建暖心工程", date: "2021-03-08" },
];
import {
  getLink,
  getLinks,
  getList,
  getStep,
  getTitle,
} from "@/api/consularCertification";
export default {
  name: "certification-information",
  data() {
    return {
      focus: "1",
      list,
      data: null,
      titleList: [],
      target: null,
    };
  },
  created() {
    this._getList();
    this.getStep();
  },
  methods: {
    changeTarget(item) {
      this.target = item;
      this.list = [];

      this.data = null;
      this.titleList.forEach((e) => {
        if (
          e.title == item.title &&
          item.contentECount > 1 &&
          item.moduleClass == "announce"
        ) {
          this._getList(item.contentCode);
          return;
        }
        if (
          e.title == item.title &&
          item.contentECount == 1 &&
          item.moduleClass == "announce"
        ) {
          getList(item.contentCode).then((res) => {
            getStep(this._.get(res, "data.records")[0].contentCode).then(
              (r) => {
                this.data = this._.get(r, "data.contentHtml") || null;
              }
            );
          });
          return;
        }
        if (e.title == item.title && item.moduleClass == "linkurl") {
          this.getLink(item.contentCode);
          return;
        }
      });
    },
    getDetail(item) {
      // pushRouter('/announcement?moduleCode=RESB234384DCDABECF&type=contentAnnounce&name=认证信息')
      if (item.contentECount > 1 && item.moduleClass == "announce") {
        this.pushRouter(
          "/announcement?moduleCode=" +
          item.contentCode +
          "&type=contentAnnounce&name=" +
          item.title + `&linkname=领事认证/${item.title}`
        );
      }
      if (item.contentECount == 1 && item.moduleClass == "announce") {
        getList(item.contentCode).then((res) => {
          this.pushRouter(
            `/guide?contentCode=${res.data.records[0].contentCode}&type=contentAnnounce&linkname=${res.data.records[0].contentTitle}`
          );
        });
      }
    },
    jumpNewUrl() {
      window.open(
        "https://zwfw.fujian.gov.cn/province-dept/index?type=2&siteUnid=5D703F1FEC38FD23C65A4D08D4CC1A27&noNotice=false&randomNum=0.2948945334696873"
      );
    },
    getLink(code) {
      getLinks(code).then((res) => {
        this.list = res.data.records || null;
        console.log(this.list);
      });
    },
    getStep() {
      getTitle().then((res) => {
        this._.get(res, "data.records").forEach((e) => {
          this.titleList.push({
            title: e.moduleName,
            contentCode: e.moduleCode,
            contentECount: e.contentECount,
            moduleClass: e.moduleClass,
          });
        });
        // this.target = this.titleList[0] || null
        this.changeTarget(this.titleList[0]);
      });
      // getStep('RES6667B5CF324C0A5').then(res => {
      //   this.data = this._.get(res, 'data.contentHtml')
      // })
    },
    goDetail(item) {
      const type = "contentAnnounce";
      this.pushRouter(
        `/guide?contentCode=${item.contentCode}&type=${type}&linkname=领事认证/信息咨询/详情`
      );
    },
    // 获取链接
    _getLink(name) {
      getLink(name).then((res) => {
        window.open(this._.get(res, "data.linkUrl"));
      });
    },
    _getList(contentCode) {
      getList(contentCode).then((res) => {
        this.list = this._.get(res, "data.records", []);
        console.log('---数据---', this.list)
      });
    },
  },
};
</script>

<style>
.content-desc>p {
  margin: 0;
  padding: 0;
}

.content-desc>p>img {
  width: 100%;
}
</style>
<style scoped lang='less'>
.content {
  width: 100%;
  position: relative;
  margin: 60px 0;
  height: 360px;

  &-box {
    width: 1140px;
    position: relative;
    margin: auto;
    // left: 50%;
    // transform: translateX(-50%);
    text-align: left;
    font-size: 0px;
  }
}

.common {
  display: inline-block;
  font-size: 16px;
  vertical-align: top;
}

.left-content {
  width: 700px;
  margin-right: 60px;
}

.content-title {
  width: 100px;
  display: inline-block;
  font-size: 20px;
  height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  padding-bottom: 15px;
  //  border-bottom: 1px solid #CBB486;
  cursor: pointer;
  margin-right: 25px;
  text-align: center;
}

.right-content {
  width: 380px;
}

.content-desc {
  p {
    cursor: pointer;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 30px 0 30px 15px;
    position: relative;
    border-bottom: 1px solid RGBA(238, 238, 238, 1);

    span {
      font-size: 16px;
    }

    span:first-of-type {
      width: 80%;
      text-align: left;
    }

    span:last-of-type {
      color: rgba(188, 190, 192, 1);
      font-size: 14px;
    }

    &:hover {
      color: rgba(203, 180, 134, 1);
    }

    img {
      width: 100% !important;
      height: 100% !important;
    }
  }

  p::before {
    content: "";
    display: inline-block;
    width: 5px;
    height: 5px;
    background: rgba(203, 180, 134, 1);
    border-radius: 50%;
    position: absolute;
    top: 38px;
    left: 0px;
  }
}

.right-box1:hover {
  border: 1px solid #decba4;
}

.right-box2 p:hover {
  color: rgba(203, 180, 134, 1);

  p {
    font-size: 32px;
  }
}

.right-box1 {
  width: 380px;
  height: 180px;
  background: #dcdcdc;
  border: 1px solid transparent;
  margin-top: 5px;

  p {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    padding-top: 41px;
    padding-left: 39px;
  }

  .btn-wrap {
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: center;

    >div {
      height: 56px;
      padding: 0 6px;
      // width: 140px;
      line-height: 56px;
      background: #a52a2a;
      border-radius: 6px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      // margin-left: 40px;
      cursor: pointer;
      &:hover{
        background: #8b0000;
      }
    }
  }

  // div>div {
  //   display: inline-block;
  //   

  // }

  // div>div:last-of-type {
  //   margin-left: 20px;
  // }

  // div>div:hover {
  //   background: #8b0000;
  // }
}

.cert-link {
  color: #000000;
}

.cert-link:hover {
  color: #cbb486;
}

.right-box2 {
  width: 380px;
  height: 160px;
  margin-top: 40px;
  background: #dcdcdc;
  border: 1px solid transparent;

  p {
    font-size: 25px;
    font-family: Source Han Serif CN;
    font-weight: 800;
    color: #3a3a3a;
    text-align: center;
    padding: 0;
    margin: 0;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/consularCertification/siderContent-02.vue